import { useStore } from '@stores';
import { useEffect } from 'react';

export const useOrderPresences = (orderId: string | undefined) => {
  const { orderStore } = useStore();
  const { presences, presenceLoading } = orderStore;

  useEffect(() => {
    orderId && orderStore.getPresences({ orderId, maxResultCount: 50, skipCount: 0 });

    return () => {
      orderStore.resetPresences();
    };
  }, [orderStore, orderId]);

  return { presences, presenceLoading };
};
